export default __webpack_public_path__ + "static/media/switch.e6508fac.svg";